import { useEffect } from 'react';
import DynamicTitle from '@/components/DynamicTitle';
import Footer from '@/components/Footer';

// Declare fbq function for TypeScript
declare global {
  interface Window {
    fbq: (action: string, event: string, params?: any) => void;
  }
}

export default function ThankYou() {
  useEffect(() => {
    // Ensure Purchase fires after Meta Pixel (fbq) is available
    let isCancelled = false;

    const trackPurchase = () => {
      try {
        window.fbq('track', 'Purchase', {
          content_name: 'Vibe Coding Course',
          content_category: 'Online Course',
          content_type: 'course',
          value: 60000.0,
          currency: 'AMD',
          num_items: 1,
        });
      } catch (e) {
        console.warn('Meta Pixel fbq not ready to track Purchase yet:', e);
      }
    };

    const waitForFbq = (maxWaitMs = 5000, intervalMs = 100) => {
      const start = Date.now();
      const interval = setInterval(() => {
        if (isCancelled) {
          clearInterval(interval);
          return;
        }
        if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
          clearInterval(interval);
          trackPurchase();
        } else if (Date.now() - start >= maxWaitMs) {
          clearInterval(interval);
          // Final attempt if available
          if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
            trackPurchase();
          }
        }
      }, intervalMs);
      return interval;
    };

    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      trackPurchase();
    } else {
      waitForFbq();
    }

    return () => {
      isCancelled = true;
    };
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <DynamicTitle title="Thank You - Payment Successful" />
      
      <main className="container mx-auto px-4 py-20">
        <div className="flex flex-col items-center justify-center min-h-[70vh] text-center">
          <div className="max-w-4xl mx-auto space-y-4">
            <div className="flex justify-center mb-2">
              <img 
                src="/lovable-uploads/congrats-gif-1.gif" 
                alt="Congratulations animation"
                className="w-64 h-64 md:w-80 md:h-80 lg:w-96 lg:h-96 object-contain"
              />
            </div>
            
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-white glow-text leading-tight">
              Թույն, վճարումը կատարվեց 🥳։ Արդեն պետքա որ մեյլիդ ստացած լինես նամակ, որտեղ կգտնես էն ամենն, ինչ քեզ պետք ա վայբ կոդեռ դառնալու համար ։Դ
            </h1>
            
            <p className="text-gray-400 text-lg">
              Ֆսյէ, մնացած ինֆոն արդեն մեյլով։
            </p>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}